import { useEffect, useState } from 'react';

const cachedScripts = new Set();

/**
 * Dynamically load an external script and track its state.
 * @param {string} src - The URL of the script to load.
 * @returns {'idle' | 'loading' | 'ready' | 'error'}
 */
export function useExternalScript(src) {
  const [status, setStatus] = useState(src ? 'loading' : 'idle');

  useEffect(() => {
    if (!src) return;

    if (cachedScripts.has(src)) {
      setStatus('ready');
      return;
    }

    let script = document.querySelector(`script[src="${src}"]`);

    if (!script) {
      script = document.createElement('script');
      script.src = src;
      script.type = 'module';
      script.async = true;
      script.defer = true;

      const handleLoad = () => {
        cachedScripts.add(src);
        setStatus('ready');
      };

      const handleError = () => {
        script.remove();
        setStatus('error');
      };

      script.addEventListener('load', handleLoad);
      script.addEventListener('error', handleError);

      document.body.appendChild(script);

      return () => {
        script.removeEventListener('load', handleLoad);
        script.removeEventListener('error', handleError);
      };
    } else {
      setStatus('ready');
    }
  }, [src]);

  return status;
}
